import { useState } from "react";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import { Link } from "react-router-dom";

const faqCategories = [
  { id: "product", label: "商品相關" },
  { id: "store", label: "門市與試穿" },
  { id: "service", label: "服務與退換" },
  { id: "member", label: "會員與通知" },
];

const faqs = [
  { id: 1, category: "product", q: "Outlet 商品是否為正品？", a: "是的，我們販售的所有商品均為台灣設計師品牌的正品服飾。Outlet 的形式代表的是以更親切的價格讓消費者入手品牌經典款，商品品質與正規門市完全相同，絕無仿冒或瑕疵品，請您安心選購。" },
  { id: 2, category: "product", q: "有哪些尺寸可以選擇？", a: "我們提供 S、M、L、XL 等多種尺寸，部分款式亦有 Free Size。每件商品均附有詳細的尺寸對照表，建議您參考胸圍、腰圍、臀圍數據選購。如有疑問，歡迎加入 LINE 諮詢，我們的造型顧問將協助您挑選最合適的尺寸。" },
  { id: 3, category: "product", q: "商品的面料與洗滌方式為何？", a: "每件商品均附有完整的材質說明與洗滌標籤。大部分商品建議手洗或乾洗，以維持面料質感。詳細的保養方式請參考各商品頁面的說明，或加入 LINE 詢問我們的專業建議。" },
  { id: 4, category: "store", q: "可以到門市試穿嗎？", a: "當然可以！我們非常鼓勵您親自到台中實體門市試穿，感受每件衣服的版型與質感。您可以直接到店或事先預約，預約試穿可確保我們為您安排專屬的造型顧問服務時段，讓您有更舒適的試穿體驗。" },
  { id: 5, category: "store", q: "如何預約到店試穿？", a: "您可以透過以下方式預約：1. 點擊網站上的「預約試穿」按鈕填寫表單；2. 加入 LINE 官方帳號直接留言預約；3. 撥打門市電話預約。我們會在 24 小時內與您確認預約時間。" },
  { id: 6, category: "store", q: "門市地址與營業時間？", a: "門市位於台中市西屯區台灣大道三段XXX號，鄰近捷運台灣大道站。營業時間為週二至週日 11:00–19:30，週一公休。建議搭乘大眾運輸或使用附近公共停車場，停車十分便利。" },
  { id: 7, category: "service", q: "是否可以退換貨？", a: "可以。購買後7日內如有商品瑕疵或尺寸問題，可申請退換貨服務。退換貨商品需保持吊牌完整、未經洗滌或穿著的原始狀態。Outlet 特惠商品如有特別標示不退換，將於購買前明確告知。詳細退換貨流程請洽 LINE 客服。" },
  { id: 8, category: "service", q: "是否提供網路購物服務？", a: "目前我們以實體門市服務為主，鼓勵您親自試穿感受衣服的版型與質感。如有特定需求，歡迎加入 LINE 官方帳號，我們可為您提供商品諮詢及相關服務安排。未來網路購物功能規劃中，敬請期待。" },
  { id: 9, category: "member", q: "如何加入會員？", a: "目前可透過加入 LINE 官方帳號成為我們的會員，即可優先收到新品上架通知、限量活動資訊及專屬優惠。詳細會員制度正在規劃完善中，加入後我們將第一時間通知您最新的會員福利。" },
  { id: 10, category: "member", q: "如何收到新品與活動通知？", a: "加入我們的 LINE 官方帳號是最即時的方式，每次新品上架、換季特賣或節日優惠活動，我們都會透過 LINE 第一時間通知您。您也可以訂閱網站電子報，定期收到穿搭靈感與新品資訊。" },
  { id: 11, category: "member", q: "可以透過 LINE 詢問商品嗎？", a: "完全可以！加入 LINE 官方帳號後，您可以直接詢問任何商品的尺寸、顏色、版型、穿搭建議，甚至請我們協助挑選適合您的款式。我們的造型顧問都很樂意為您提供最真誠的建議。" },
  { id: 12, category: "store", q: "如何前往門市，停車是否方便？", a: "門市位於台中市西屯區台灣大道三段，交通便利，鄰近捷運台灣大道站步行約5分鐘可達。開車前往的顧客可使用附近的公共停車場，停車十分方便。如需詳細交通指引，歡迎加入 LINE 詢問。" },
];

export default function FAQ() {
  const [activeCategory, setActiveCategory] = useState("product");
  const [openId, setOpenId] = useState<number | null>(1);

  const filtered = faqs.filter(f => f.category === activeCategory);

  return (
    <div className="min-h-screen bg-[#faf8f5]">
      <Navbar />
      <main>
        {/* Hero */}
        <section className="relative h-[42vh] min-h-[320px] overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=elegant%20women%20fashion%20boutique%20warm%20cream%20beige%20interior%20soft%20natural%20light%20minimalist%20luxury%20atmosphere%20designer%20brand%20quality%20clothing%20display&width=1400&height=600&seq=faqhero&orientation=landscape"
            alt="常見問題"
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/55" />
          <div className="absolute inset-0 flex flex-col items-center justify-center text-center px-6">
            <p className="text-[#f5d8b8] text-[1rem] tracking-[0.3em] uppercase font-medium mb-3">FAQ</p>
            <h1 className="text-white text-[2.75rem] md:text-[3.25rem] font-bold leading-[1.3] mb-3">常見問題</h1>
            <p className="text-white/80 text-[1.1875rem] max-w-lg leading-[1.75]">我們整理了顧客最常詢問的問題，希望能解答您的疑慮，讓您安心選購。</p>
          </div>
        </section>

        {/* FAQ Content */}
        <section className="py-16 md:py-24">
          <div className="w-full px-6 md:px-16 max-w-[1000px] mx-auto">
            {/* Category Tabs */}
            <div className="flex flex-wrap gap-3 mb-12 justify-center">
              {faqCategories.map(cat => (
                <button
                  key={cat.id}
                  onClick={() => { setActiveCategory(cat.id); setOpenId(null); }}
                  className={`px-6 py-2.5 rounded-full text-[1rem] font-medium transition-all duration-200 cursor-pointer whitespace-nowrap ${
                    activeCategory === cat.id ? "bg-[#3d2b1f] text-[#faf8f5]" : "bg-[#f5ede4] text-[#7a6455] hover:bg-[#e8d8c8]"
                  }`}
                >
                  {cat.label}
                </button>
              ))}
            </div>

            {/* Accordion */}
            <div className="flex flex-col gap-3">
              {filtered.map(faq => (
                <div key={faq.id} className="bg-white rounded-lg overflow-hidden border border-[#ede8e0]">
                  <button
                    onClick={() => setOpenId(openId === faq.id ? null : faq.id)}
                    className="w-full flex items-center justify-between px-7 py-5 text-left cursor-pointer hover:bg-[#faf5ef] transition-colors"
                  >
                    <span className="text-[#3d2b1f] text-[1.125rem] font-semibold leading-[1.5] pr-4">{faq.q}</span>
                    <span className={`w-8 h-8 flex items-center justify-center rounded-full flex-shrink-0 transition-all duration-300 ${openId === faq.id ? "bg-[#8B5E52] text-white" : "bg-[#f5ede4] text-[#8B5E52]"}`}>
                      <i className={`text-base transition-transform duration-300 ${openId === faq.id ? "ri-subtract-line" : "ri-add-line"}`}></i>
                    </span>
                  </button>
                  {openId === faq.id && (
                    <div className="px-7 pb-6">
                      <div className="border-t border-[#ede8e0] pt-5">
                        <p className="text-[#7a6455] text-[1.1875rem] leading-[1.75]">{faq.a}</p>
                      </div>
                    </div>
                  )}
                </div>
              ))}
            </div>

            {/* Still have questions */}
            <div className="mt-16 bg-[#f5ede4] rounded-lg p-10 text-center">
              <h2 className="text-[#3d2b1f] text-[1.625rem] font-bold mb-3">還有其他問題？</h2>
              <p className="text-[#7a6455] text-[1.1875rem] leading-[1.75] mb-7 max-w-md mx-auto">
                歡迎加入我們的 LINE 官方帳號，或前往門市資訊頁查詢聯絡方式，我們很樂意為您解答任何疑問。
              </p>
              <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
                <a
                  href="https://line.me"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center gap-2 px-7 py-3.5 bg-[#3d2b1f] text-[#faf8f5] rounded-full text-[1.0625rem] font-semibold hover:bg-[#8B5E52] transition-colors cursor-pointer whitespace-nowrap"
                >
                  <i className="ri-line-fill"></i> 加入 LINE 詢問
                </a>
                <Link
                  to="/contact"
                  className="flex items-center gap-2 px-7 py-3.5 border-2 border-[#3d2b1f] text-[#3d2b1f] rounded-full text-[1.0625rem] font-semibold hover:bg-[#3d2b1f] hover:text-[#faf8f5] transition-colors cursor-pointer whitespace-nowrap"
                >
                  <i className="ri-map-pin-line"></i> 查看門市資訊
                </Link>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
